var f = function(event) {
  var currentTarget = event.currentTarget
  var tab_id = currentTarget.dataset.tab;
  
  let elements = currentTarget.parentElement.querySelectorAll('li');
  elements.forEach((element) => {
    element.classList.remove('current');
  })

  let containerTab = document.querySelector('.product-more-info-tab-content.current');
  containerTab.classList.remove('current')
  containerTab.removeAttribute('open');
  currentTarget.classList.add('current');
  let containerTabNew = document.getElementById(tab_id);
  containerTabNew.classList.add('current')
  containerTabNew.setAttribute('open', true);
}
document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('ul.product-more-info-tabs > li');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', f);
    trigger.addEventListener('tap', f);
  });
  let containerTab = document.querySelector('.product-more-info-tab-content.current');
  containerTab.setAttribute('open', true);
});